import s from '../styles/jujitsu-lexique.module.css';
import OJLayout from '../components/layout';
import Head from 'next/head'
import Link from 'next/link'
import {useEffect, useState} from "react";
import * as envConstants from '../components/constants';

const SectionLexique = ({itemIDSection, itemTitreSection, itemElements}) => {
    const [sectionShow, setSectionShow] = useState(true);
    const buttonSectionHandleClick = () => {setSectionShow(!sectionShow);};
    return (
        <div id={itemIDSection} className={s.sectionLexDiv}>
            <button type="button" onClick={buttonSectionHandleClick} className={s.sectionLexHeader}>
                <span className={s.sectionLexTitre}>{itemTitreSection}</span>
                <svg className={`${sectionShow ? "rotate-180" : "rotate-0"} ${s.sectionLexHeaderArrow}`}
                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" ></path></svg>
            </button>
            <div className={`${sectionShow ? "max-h-fit" : "max-h-0"} transition-transform origin-top duration-500 ease-out overflow-hidden`}>
                <table className={s.elemLexTable}>
                    {itemElements.map((data) => (
                    <tr key={data.nomJAP}>
                        <td className={s.elemLnomJAP}>{data.nomJAP}</td>
                        <td className={s.elemLnomFRA}>{data.nomFRA}</td> 
                    </tr>                     
                    ))}
                </table>
            </div>         
        </div>  
    );
};

// Bouton  Flottant permettant de remonter en haut de page
const BoutonFlottantGoUp = () => {
    function onClickButtonGoUp(){
        // document.body.scrollTop = 0; // For Safari
        // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        const mainDivtoScroll = document.getElementById("mainDivLayout");
        mainDivtoScroll.scrollTo({top: 0, behavior: "smooth"});
    }    
    return (
        <button id="btnFlotantGoUp" className={s.divBoutonFlottant} onClick={onClickButtonGoUp}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" /></svg>
        </button>
    );
};


export default function JujitsuLexique() {
    const [showFlotingButtonGoUp, setShowFlotingButton] = useState(false);
    const listenerScroll = () => {
        const mainDivtoScroll = document.getElementById("mainDivLayout");
        mainDivtoScroll.scrollTop > 80 ? setShowFlotingButton(true) : setShowFlotingButton(false);
    }
    useEffect(() => {
        // Réccupère la div Main pour gérer le scrolling
        const mainDivtoScroll = document.getElementById("mainDivLayout");
        mainDivtoScroll.addEventListener('scroll', listenerScroll);
        return () => mainDivtoScroll.removeEventListener('scroll', listenerScroll);        
    }, []);

    const lexiqueGeneral = [
        {nomJAP: "JU JITSU", nomFRA: "Techniques de souplesse"},
        {nomJAP: "UKE", nomFRA: "Celui qui subit l’action (souvent \"l'attaquant\")"},
        {nomJAP: "TORI", nomFRA: "Celui qui fait l'action (souvent \"le défenseur\")"},        
        {nomJAP: "SENSEI", nomFRA: "Professeur"},
        {nomJAP: "JOSEKI", nomFRA: "Jury"},
        {nomJAP: "BUDO", nomFRA: "Art martial japonais"},
        {nomJAP: "KYU", nomFRA: "Grade inférieur / de couleur"},
        {nomJAP: "DAN", nomFRA: "Grade supérieur"},
        {nomJAP: "WAZA", nomFRA: "Technique de (pratique)"}
    ];
    const lexiqueHabit = [
        {nomJAP: "JUDOGI", nomFRA: "Habit du judoka/jujitsuka"},
        {nomJAP: "KEIGOGI", nomFRA: "Habit du praticant"},
        {nomJAP: "ERI", nomFRA: "Revers du judogi"},        
        {nomJAP: "SODE", nomFRA: "Manche du judogi"},
        {nomJAP: "OBI", nomFRA: "Ceinture"},
        {nomJAP: "ZORI", nomFRA: "Chaussures japonaises"},
        {nomJAP: "TATAMI", nomFRA: "Tapis d'entrainement"}
    ];
    const lexiqueEntrainement = [
        {nomJAP: "DOJO", nomFRA: "Salle d’entraînement"},
        {nomJAP: "RANDORI", nomFRA: "Combat d’entrainement sans notion de victoire ou défaite"},
        {nomJAP: "SHIAI", nomFRA: "Combat pour la victoire"},        
        {nomJAP: "KATA", nomFRA: "Forme / Exercice traditionnel d’apprentissage des principes"},
        {nomJAP: "UCHI KOMI", nomFRA: "Répétition d’une technique sur un partenaire Sans projection"},
        {nomJAP: "NAGE KOMI", nomFRA: "Répétition d’une technique sur un partenaire Avec projection"},
        {nomJAP: "YAKU SOKU GEIKO", nomFRA: "Combat d’entrainement sans opposition"},
        {nomJAP: "KAKARI GEIKO", nomFRA: "Combat d’entrainement avec consignes"},
        {nomJAP: "KAN GEIKO", nomFRA: "Entraînement dans le froid"},
        {nomJAP: "SHOCHU GEIKO", nomFRA: "Entraînement dans la chaleur"}
    ];
    const lexiqueArbitrage = [
        {nomJAP: "REI", nomFRA: "Saluez"},
        {nomJAP: "HAJIME", nomFRA: "Commencez"},
        {nomJAP: "MATTE", nomFRA: "Attendez (assimilé \"Arrèter\" en cours)"},        
        {nomJAP: "OSAEKOMI", nomFRA: "Début d’immobilisation"},
        {nomJAP: "TOKETA", nomFRA: "Sortie d’immobilisation"},
        {nomJAP: "YOSHI", nomFRA: "Continuez"},
        {nomJAP: "SOREMADE", nomFRA: "Fin du combat"},
        {nomJAP: "HIKIWAKE", nomFRA: "Egalité"}
    ];
    const lexiqueCorps = [
        {nomJAP: "UBI", nomFRA: "doigt"},
        {nomJAP: "KOTE", nomFRA: "poignet (petite main)"},
        {nomJAP: "TE", nomFRA: "Main"},        
        {nomJAP: "UDE", nomFRA: "Bras"},
        {nomJAP: "HIJI", nomFRA: "Coude"},
        {nomJAP: "EMPI", nomFRA: "Pointe du Coude"},
        {nomJAP: "KATA", nomFRA: "Epaule"},
        {nomJAP: "HARA", nomFRA: "Ventre, ceinture abdominale"},
        {nomJAP: "KOSHI / GOSHI", nomFRA: "Hanche"},
        {nomJAP: "MATA", nomFRA: "Cuisse"},
        {nomJAP: "MOMO", nomFRA: "l'Aine"},
        {nomJAP: "ASHI", nomFRA: "Jambe"},
        {nomJAP: "HIZA", nomFRA: "Genoux"},
        {nomJAP: "ATAMA", nomFRA: "Tête"},
        {nomJAP: "JODAN", nomFRA: "Niveau tête / épaules"},
        {nomJAP: "CHUDAN", nomFRA: "Niveau du tronc"},
        {nomJAP: "GEDAN", nomFRA: "Niveau sous la ceinture"}
    ];
    const lexiqueDirections = [
        {nomJAP: "MAE", nomFRA: "de Face"},
        {nomJAP: "YOKO", nomFRA: "de Coté"},
        {nomJAP: "USHIRO", nomFRA: "Derrière"},        
        {nomJAP: "URA", nomFRA: "Arrière"},
        {nomJAP: "MAWASHI", nomFRA: "Circulaire"},
        {nomJAP: "AGE", nomFRA: "Lever, remonter, en remontant"},
        {nomJAP: "UCHI", nomFRA: "de l'intérieur vers l'extérieur"},
        {nomJAP: "SOTO", nomFRA: "de l'extérieur vers l'intérieur"},
        {nomJAP: "GYAKU", nomFRA: "Inversé"},
        {nomJAP: "KUZURE", nomFRA: "autre forme, variante"},
        {nomJAP: "MIGI", nomFRA: "Droite"},
        {nomJAP: "HIDARI", nomFRA: "Gauche"}
    ];
    const lexiqueTechniques = [
        {nomJAP: "O", nomFRA: "Grand"},
        {nomJAP: "KO", nomFRA: "Petit"},
        {nomJAP: "ATEMI", nomFRA: "Technique de frappe Pieds ou Poings"},        
        {nomJAP: "NAGE WAZA", nomFRA: "Technique de Projections"},
        {nomJAP: "NE WAZA", nomFRA: "Technique de travail au sol"},
        {nomJAP: "SUTEMI", nomFRA: "Technique de sacrifice"},
        {nomJAP: "JIME", nomFRA: "Technique d'Etranglements"},
        {nomJAP: "BARAI", nomFRA: "Fauchage / Balayage"},
        {nomJAP: "HARAI", nomFRA: "Balayage (pour projection)"},
        {nomJAP: "GARAMI", nomFRA: "par enroulement"},
        {nomJAP: "GATAME", nomFRA: "luxation, Tendu"},
        {nomJAP: "GURUMA", nomFRA: "enroulement autour"},
        {nomJAP: "GAKE", nomFRA: "crochetage / accrochage"},
        {nomJAP: "DORI", nomFRA: "prendre, saisir"},
        {nomJAP: "HANE", nomFRA: "Bondir, sauter, percuter du dessous"},
        {nomJAP: "HINERI", nomFRA: "en tordant"},
        {nomJAP: "HISHIGI", nomFRA: "Plier, tendre, luxation, cassé"},
        {nomJAP: "IRIMI", nomFRA: "En entrant dans l'attaque"},
        {nomJAP: "KEN KEN", nomFRA: "Petit bond rapide"},
        {nomJAP: "DE", nomFRA: "en Avant / Sortir"},
        {nomJAP: "SEOI", nomFRA: "Charger sur le dos"},
        {nomJAP: "HIKI", nomFRA: "Tirer"},
        {nomJAP: "TSURI", nomFRA: "Pêcher"}
    ];
    const lexiqueCompter= [
        {nomJAP: "ICHI", nomFRA: "Un"},
        {nomJAP: "NI", nomFRA: "Deux"},
        {nomJAP: "SAN", nomFRA: "Trois"},        
        {nomJAP: "SHI", nomFRA: "Quatre"},
        {nomJAP: "GO", nomFRA: "Cinq"},
        {nomJAP: "ROKU", nomFRA: "Six"},
        {nomJAP: "SISHI", nomFRA: "Sept"},
        {nomJAP: "HACHI", nomFRA: "Huit"},
        {nomJAP: "KYU", nomFRA: "Neuf"},
        {nomJAP: "JU", nomFRA: "Dix"}
    ];
    const lexiqueDeplacements = [
        {nomJAP: "TAI SABAKI", nomFRA: "déplacement circulaire"},
        {nomJAP: "TSUGI ASHI", nomFRA: "déplacement en pas chassés (suivants)"},
        {nomJAP: "AYUMI ASHI", nomFRA: "déplacement en demi-cercle (croissant de lune)"}
    ];
    const lexiquePositions = [
        {nomJAP: "ZEN KUTSU DACHI", nomFRA: "position de garde d'attaque"},
        {nomJAP: "KIBA DACHI", nomFRA: "position cavalier de fer"}, 
        {nomJAP: "KOKUTSU DACHI", nomFRA: "position reculé sur appuie arrière (70%)"},
        {nomJAP: "NEKO DACHI", nomFRA: "position reculé sur appuie arrière (90%)"},       
        {nomJAP: "SHIKO DACHI", nomFRA: "position cavalier de fer, pied vers l'extérieur"},
        {nomJAP: "SANCHI DACHI", nomFRA: "position cavalier de fer, pied vers l'intérieur"},
        {nomJAP: "KOSA DACHI", nomFRA: "position avec une jambe croisée derrière"},
        {nomJAP: "HEISOKU DACHI", nomFRA: "position jambe tendu, pieds serrés"}
    ];
    const lexiquePostures = [
        {nomJAP: "SHISEI", nomFRA: "Posture"},
        {nomJAP: "SHIZEN HONTAI", nomFRA: "Posture naturelle"},     
        {nomJAP: "JIGO HONTAI / JIGOTAI", nomFRA: "Posture de défense"},
        {nomJAP: "KAMAE", nomFRA: "Position"},
        {nomJAP: "SEIZA", nomFRA: "Position assise à genoux"},
        {nomJAP: "KIZA / KYOSHI NO KAMAE", nomFRA: "Position haute à genoux"},
        {nomJAP: "ANZA", nomFRA: "Position assise en tailleur"}
    ];
    const lexiqueDivers = [
        {nomJAP: "DO", nomFRA: "la voie"},
        {nomJAP: "AI", nomFRA: "harmonie"},
        {nomJAP: "HAI", nomFRA: "\"Oui\""},        
        {nomJAP: "IAI", nomFRA: "Dégaigner le sabre"},
        {nomJAP: "KAMIZA", nomFRA: "Côté élevé (souvent avec une photo de J. Kano)"},
        {nomJAP: "MA AI", nomFRA: "Distance entre Tori et Uke"},
        {nomJAP: "TOMA", nomFRA: "Distance lointaine"},
        {nomJAP: "CHIKAMA", nomFRA: "Distance proche"},
        {nomJAP: "UCHIMA", nomFRA: "Distance nulle (corps à corps)"}
    ];

    return (
    <OJLayout>
        <Head><title>{envConstants.SITE_NAME_OJ} - Lexique</title></Head>
        <div id="divMainJLexique" className={s.divJLexique} >
            <div className={s.divTitreEtMenuFixed}>
                {/* Titre de la page */}
                <p className={s.title}>Lexique utile</p>
                {/* Zone petit Menu des sections */}
                <div className={s.divMenuItemLexique}>
                    <Link href={"#General"}><a className={s.menuItemLexique}>Général</a></Link>
                    <Link href={"#Habit"}><a className={s.menuItemLexique}>Habit</a></Link>
                    <Link href={"#Entrainement"}><a className={s.menuItemLexique}>Entrainement</a></Link>
                    <Link href={"#Arbitrage"}><a className={s.menuItemLexique}>Arbitrage</a></Link>
                    <Link href={"#Corps"}><a className={s.menuItemLexique}>Corps</a></Link>
                    <Link href={"#Directions"}><a className={s.menuItemLexique}>Directions</a></Link>
                    <Link href={"#Techniques"}><a className={s.menuItemLexique}>Techniques</a></Link>
                    <Link href={"#Compter"}><a className={s.menuItemLexique}>Compter</a></Link>
                    <Link href={"#Deplacements"}><a className={s.menuItemLexique}>Déplacements</a></Link>
                    <Link href={"#Positions"}><a className={s.menuItemLexique}>Positions</a></Link>
                    <Link href={"#Postures"}><a className={s.menuItemLexique}>Postures</a></Link>
                    <Link href={"#Divers"}><a className={s.menuItemLexique}>Divers</a></Link>
                </div>
            </div>
            {/* Zones des sections du Lexique */}
            <SectionLexique itemIDSection={"General"} itemTitreSection={"Général"} itemElements={lexiqueGeneral} />
            <SectionLexique itemIDSection={"Habit"} itemTitreSection={"Habit"} itemElements={lexiqueHabit} />
            <SectionLexique itemIDSection={"Arbitrage"} itemTitreSection={"Arbitrage"} itemElements={lexiqueArbitrage} />
            <SectionLexique itemIDSection={"Corps"} itemTitreSection={"Corps"} itemElements={lexiqueCorps} />
            <SectionLexique itemIDSection={"Directions"} itemTitreSection={"Directions"} itemElements={lexiqueDirections} />
            <SectionLexique itemIDSection={"Techniques"} itemTitreSection={"Techniques"} itemElements={lexiqueTechniques} />
            <SectionLexique itemIDSection={"Compter"} itemTitreSection={"Compter"} itemElements={lexiqueCompter} />
            <SectionLexique itemIDSection={"Deplacements"} itemTitreSection={"Deplacements"} itemElements={lexiqueDeplacements} />
            <SectionLexique itemIDSection={"Positions"} itemTitreSection={"Positions"} itemElements={lexiquePositions} />
            <SectionLexique itemIDSection={"Postures"} itemTitreSection={"Postures"} itemElements={lexiquePostures} />
            <SectionLexique itemIDSection={"Divers"} itemTitreSection={"Divers"} itemElements={lexiqueDivers} />
            
            {/* Bouton flotant de retour en haut */}
            <div className={showFlotingButtonGoUp ? "block" : "hidden"}>
                <BoutonFlottantGoUp />
            </div>
        </div>
    </OJLayout>
)}